<template>
	<div class="o-dashboard">

		<c-tabs :tabs="tabs" @selectTab="setTab">

			<c-tab v-if="tab == 'items'">

				<c-table
					:filters="[ 
						{ name: 'client', label: 'Alle eindklanten', options: endClients},
						{ name: 'reseller', label: 'Alle resellers', options: resellers }
					]"
					ref="table"
					:columns="columnsProducts"
					:endpoint="'/api/products'"
					:placeholder="'Zoeken op productnaam, artikelnummer, eindklant, reseller, serienummer of ordernummer'">
				</c-table>

			</c-tab>

			<c-tab v-if="tab == 'bundles'">
				<c-table
					:small="true"
					:columns="columnsBundles"
					:endpoint="'/api/bundles'"
					:placeholder="'Zoeken op bundelnaam, eindklant of reseller'">
				</c-table>
			</c-tab>

		</c-tabs>

		<c-new-stock
			v-show="modal"
			@close="modal=false"
			@added="load"
			:size="'medium'"
			:title="'Nieuw voorraad'">
		</c-new-stock>

		<c-bulk-order
			v-show="modalBulk"
			@close="modalBulk=false"
			@added="load"
			:size="'medium'">
		</c-bulk-order>

		<c-import-stock
			v-show="modalImport"
			@close="modalImport=false"
			@added="load"
			:size="'medium'"
			:title="'Import voorraad'">
		</c-import-stock>

		<c-export
			v-show="modalExport"
			@close="modalExport=false"
			:size="'medium'"
			:title="'Exporteer voorraad'"
			:search="$refs.table?.selection?.search?.all || ''"
			:direction="$refs.table?.sort?.direction || ''"
			:sort="$refs.table?.sort?.column || ''"
			:filters="$refs.table?.selection?.filters">
		</c-export>

	</div>

</template>
<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';
import CTabs from '@components/tab/Container';
import CTab from '@components/tab/Element';
import CNewStock from '@app/modals/NewStock';
import CImportStock from '@app/modals/ImportStock';
import CBulkOrder from '@app/modals/BulkOrder';
import CExport from '@app/modals/Export';

export default {
	mixins: [ View, Form ],
	components: { CTable, CNewStock, CImportStock, CBulkOrder, CTabs, CTab, CExport },
	data() {
		return {
			modal: false,
			modalImport: false,
			modalExport: false,
			modalBulk: false,
			tab: 'items',
			tabs: [
				{ name:'items', label: 'Artikelen' },
				{ name:'bundles', label: 'Bundels' }
			]
		}
	},
	methods: {
		setTab(tab) {
			this.tab = tab;
		},
		openModal() {
			this.modal = true;
		},
		openModalImport(){
			this.modalImport = true;
		},
		openModalBulk(){
			this.modalBulk = true;
		},
		load(){
			this.$refs.table.load();
		},
        exportStock() {
			this.modalExport = true;
        }
	},
	created() {
		this.$store.dispatch('listener/on', {
			event: 'new-stock',
			listener: this.openModal
		});
		this.$store.dispatch('listener/on', {
			event: 'import',
			listener: this.openModalImport
		});
		this.$store.dispatch('listener/on', {
			event: 'export',
			listener: this.exportStock
		});
		this.$store.dispatch('listener/on', {
			event: 'bulk',
			listener: this.openModalBulk
		});
	},
	beforeUnmount() {
		this.$store.dispatch('listener/off', {
			event: 'new-stock',
			listener: this.openModal
		});
		this.$store.dispatch('listener/off', {
			event: 'import',
			listener: this.openModalImport
		});
        this.$store.dispatch('listener/off', {
            event: 'export',
            listener: this.exportStock
        });
		this.$store.dispatch('listener/off', {
			event: 'bulk',
			listener: this.openModalBulk
		});
	},
	computed: {
		columnsProducts() {
			return [
				{ name: 'name', label: 'Productnaam', sortable: true, sort: true, width: 240 },
				{ name: 'article_number', label: 'Artikelnr', sortable: true },
				{ name: 'items_in_stock', label: 'Voorraad', sortable: true },
				{ name: 'available_items', label: 'Op afroep', sortable: true },
				{name: 'items_at_location', label: 'Klantlocatie', sortable: true},
				{ name: 'items_in_use', label: 'In gebruik', sortable: true },
				{ name: 'client.name', label: 'Eindklant', sortable: true },
				{ name: 'client.parent.name', label: 'Reseller', sortable: true },
				{ name: "id", label: "", component: 'CColumnButton', props: { route: 'stockDetail' }},
			];
		},
		columnsBundles() {
			return [
				{ name: 'name', label: 'Bundelnaam', sortable: true, sort: true },
				{ name: 'products.length', label: 'Aantal artikelen' },
				{ name: 'client.name', label: 'Eindklant', sortable: true },
				{ name: 'client.parent.name', label: 'Reseller', sortable: true },
				{ name: 'id', label: '', component: 'CColumnButton', props: { route: 'bundleDetail' }},
			];
		},
		resellers() {
			return this.$store.getters['filters/allResellers'];
		},
		endClients() {
			return this.$store.getters['filters/allEndClients'];
		}
	},
	beforeMount() {
		this.$store.dispatch('filters/fetchResellers');
		this.$store.dispatch('filters/fetchEndClients');
	},
}
</script>
